<script lang="ts">
  import commonCss from '../../css/common.pcss.json'
  import { preloadIcon } from "./SVG";

  export let i: string
  export let adaptive: boolean = false

  const sizes = {
    default: i,
    large: `${i}-large`,
    small: `${i}-small`
  }

  if (!adaptive) {
    preloadIcon(i)
  } else {
    for (let size in sizes) {
      preloadIcon(sizes[size])
    }
  }

</script>

{#if !adaptive}
  <svg {...$$restProps}>
    <use href={`#${i}`}/>
  </svg>
{:else}
  <svg {...$$restProps}>
    {#each Object.entries(sizes) as [size, icon] (size)}
      <use class={commonCss[`adaptive-icon__${size}`]} href={`#${icon}`}/>
    {/each}
  </svg>
{/if}
